import './wallbox-assistant.scss';

class WallboxAssistant {
    constructor($element) {
        this.$wallboxAssistant = $element;
        this.$wallboxAssistantMessenger = this.$wallboxAssistant;
    }

    initialize() {
        this.loadAssets();
        if (this.getConsent().includes('MARKETING')) {
            this.loadAssets();
        } else {
            this.startConsentPolling();
        }

        window.addEventListener('df-chat-open-changed', (event) => this.handleChatOpen(event));
    }

    startConsentPolling() {
        const interval = setInterval(() => {
            if (this.getConsent().includes('MARKETING')) {
                this.loadAssets();
                clearInterval(interval);
            }
        }, 1000);
    }
    handleChatOpen(event) {
        const isMarketing = this.getConsent().includes('MARKETING');
        if (!isMarketing) return;

        this.loadAssets();

        const welcomeSent = sessionStorage.getItem('df-welcome-sent');
        if (event?.detail?.isOpen && !welcomeSent) {

            // Get Parameters from DOM
            const brand = this.$wallboxAssistantMessenger.getAttribute('data-wallbox-assistant-brand');
            const language = this.$wallboxAssistantMessenger.getAttribute('data-wallbox-assistant-language');
            const market = this.$wallboxAssistantMessenger.getAttribute('data-wallbox-assistant-market');

            // Add session parameters
            if (typeof this.$wallboxAssistantMessenger.setQueryParameters === 'function') {
                this.$wallboxAssistantMessenger.setQueryParameters({
                    parameters: {
                        brand: brand,
                        market: market,
                        language: language
                    }
                });
            }

            // Fire Welcome Event
            this.$wallboxAssistantMessenger.sendQuery('welcome_event');
            sessionStorage.setItem('df-welcome-sent', 'true');
        }
    }

    // For testing, run this in browser console: document.cookie = 'elli_cookie_consent=["ESSENTIAL","ANALYTIC","MARKETING"];'
    getConsent() {
        const cookie = document.cookie.split('; ').find(row => row.startsWith('elli_cookie_consent='));

        try {
            return JSON.parse(decodeURIComponent(cookie.split('=')[1]));
        } catch (e) {
            return [];
        }
    }

    loadAssets() {
        if (window.dfAssetsLoaded) return;
        window.dfAssetsLoaded = true;

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = '/assets/layout-helper-css';
        document.head.appendChild(link);

        const script = document.createElement('script');
        script.src = '/assets/layout-helper-js';
        document.head.appendChild(script);
    }
}

export { WallboxAssistant };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;
    const $$wallboxAssistant = $context.querySelectorAll('[data-wallbox-assistant="root"]');

    $$wallboxAssistant.forEach($wallboxAssistant => {
        const wallboxAssistant = new WallboxAssistant($wallboxAssistant);
        wallboxAssistant.initialize();
    });
});
